import _ from 'lodash';

export rem from './rem'

export getColor from './getColor'
export mapProps from './mapProps'
export mapMarginPaddingProps, { viewportPadding } from './mapMarginPaddingProps'
export colors from './colors'
export media from './media'
export * as rules from './rules'

export const toBassNumber = (value) => {
    value = Number(value);
    invariant(!_.isNan(value), `toBassNumber received NaN for ${value}`)

    return value === 1 ? 0.5 : value > 1 ? value - 1 : value
}



// WEBPACK FOOTER //
// ./src/theme/index.js